<template>
  <van-popup
    v-model="visible"
    :style="{
      width: '80%',
      maxWidth: '320px',
      borderRadius: '12px',
      background: '#ffffff',
    }"
    :overlay="true"
    :close-on-click-overlay="true"
    @click-overlay="onClose"
  >
    <div class="invite-code-popup">
      <div class="popup-head">
        <span class="popup-title">填写邀请码</span>
        <van-icon name="cross" class="close-icon" @click="onClose" />
      </div>
      <div class="popup-divider" />
      <div class="popup-content">
        <div class="input-wrap">
          <input 
            class="code-input" 
            v-model="inviteCode" 
            placeholder="请输入邀请码" 
            maxlength="13"
          />
        </div>
        <div class="tips">
          该策略需填写邀请码订阅，无邀请码可联系您的AI量化专属客服或<span class="contact-link" @click="onContact">点击此处联系客服</span>
        </div>
      </div>
      <div class="popup-actions">
        <button class="btn-submit" @click="onSubmit">提交</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon } from "vant";

export default {
  name: "InviteCodePopup",
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      inviteCode: '',
    };
  },
  watch: {
    value: {
      handler(val) {
        this.visible = val;
        if (val) {
          this.inviteCode = '';
        }
      },
      immediate: true,
    },
    visible(val) {
      if (!val) {
        this.$emit("input", false);
      }
    },
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    onSubmit() {
      if (!this.inviteCode || this.inviteCode.trim().length === 0) {
        this.$toast.fail("请输入邀请码");
        return;
      }
      this.$emit("submit", this.inviteCode.trim());
    },
    onContact() {
      this.$emit("contact");
    }
  }
}
</script>

<style lang="less" scoped>
.invite-code-popup {
  display: flex;
  flex-direction: column;
}

.popup-head {
  width: 100%;
  height: 53px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}

.popup-title {
  font-family: PingFang SC, -apple-system, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.close-icon {
  position: absolute;
  right: 16px;
  font-size: 16px;
  color: #000000;
  cursor: pointer;
}

.popup-divider {
  width: 100%;
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
}

.popup-content {
  padding: 28px 28px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.input-wrap {
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border-radius: 20px;
  border: 1px solid #000000;
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.code-input {
  flex: 1;
  font-size: 14px;
  color: #333333;
  border: none;
  outline: none;
  background: transparent;
  width: 100%;
  &::placeholder {
    color: #999;
  }
}

.tips {
  font-size: 12px;
  color: #555555;
  line-height: 18px;
  text-align: center;
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;
}

.contact-link {
  color: #000000;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}

.popup-actions {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 25px 0 28px;
}

.btn-submit {
  width: 128px;
  height: 40px;
  background: #000000;
  border-radius: 20px;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>
